import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const STATUS_NORMALIZE = {
  PUBLISHED: 'Published',
  AWAITING_PUBLICATION: 'Awaiting publication',
};

const STATUS_STYLES = {
  Published: {
    background: '#556EE6',
    color: '#fff',
  },
  'Awaiting publication': {
    background: '#F7FAFC',
    color: '#74788D',
  },
};

const DEFAULT_STYLE = {
  background: '#EFF2F7',
  color: '#74788D',
};

export const StatusTag = ({ status }) => {
  const { t } = useTranslation();
  const normalized = STATUS_NORMALIZE[status?.toUpperCase?.().replace(/ /g, '_')] ?? status;
  const styles = STATUS_STYLES[normalized] ?? DEFAULT_STYLE;
  const label = t(normalized, { defaultValue: normalized });

  return (
    <Tag background={styles.background} color={styles.color}>
      {label}
    </Tag>
  );
};

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;

StatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};
